import React from 'react';
import { Select as Original } from 'antd';
export default class Input extends React.PureComponent {
    render() {
        const { forwardedRef, ...otherProps } = this.props;
        return React.createElement(Original, Object.assign({ ref: forwardedRef }, otherProps));
    }
}
